import {useSignalr} from '@known-as-bmf/react-signalr';
import {useEffect} from 'react';
import {LogLevel} from '@aspnet/signalr';
import {AuthService} from '../services/auth/authService';

export function usePreviewTourHub(messageHandler) {
  const {on} = useSignalr(`${process.env.REACT_APP_API_URI}preview-ws/tour-hub`, {
    logger: LogLevel.Error,
    accessTokenFactory() {
      return AuthService.getAuthToken();
    }
  });

  useEffect(() => {
    const sub = on('updatetour').subscribe(next =>
      messageHandler(next)
    );
    return () => sub.unsubscribe();
  }, [on, messageHandler]);
}
